import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  Table,
  Button,
  LinkRedirect
} from './styles';
import { producaov2 as api } from '../../../../../services/apis';
import swal from 'sweetalert';

const ListarCertificado = () => {

  const [search, setSearch] = useState('')
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    api
      .get('certificados/templates?page=1')
      .then(res => {
        const newTemplates = res.data.map(({ id, curso }) => ({ id, curso: curso?.curso || '' }));
        setTemplates(newTemplates);
      })
      .catch(err => {
        swal("Erro", "Modelos de certificados não encontrados !", "error");
      })
  }, []);

  return (
    <>
      <Container>
        <Title>Modelos certificados</Title>

        <ContainerInputSearch
          className="ui fluid left icon input"
        >
          <>
            <Input
              type='search'
              placeholder='Procurar aluno...'
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <Icon name="search icon" />
          </>

          <>
            <CreateButton to="/admin/ead/certificados/templates/criar">
              Criar
            </CreateButton>
          </>
        </ContainerInputSearch>

        <Table size="big" celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Id</Table.HeaderCell>
              <Table.HeaderCell>Curso</Table.HeaderCell>
              <Table.HeaderCell>Ações </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {templates
              .filter((template) => template.curso.toLowerCase().includes(search.toLowerCase()))
              .map((template) => (
                <Table.Row>
                  <Table.Cell>{template.id}</Table.Cell>
                  <Table.Cell>{template.curso}</Table.Cell>
                  <Table.Cell>
                    <>
                      <LinkRedirect to={`/admin/ead/certificados/templates/editar/${template.id}`}>
                        <Button
                          icon="edit icon"
                          info="edit"
                        />
                      </LinkRedirect>
                    </>
                  </Table.Cell>
                </Table.Row>
              ))}

          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                <Menu floated="right" pagination>
                  <Menu.Item as="a" icon>
                    <Icon name="chevron left" />
                  </Menu.Item>
                  <Menu.Item as="a" icon>
                    <Icon name="chevron right" />
                  </Menu.Item>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Container>
    </>
  );
}

export default ListarCertificado;